module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "approve-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": "",
      "sm12": "",
      "mx-3": "",
      "py-3": ""
    }
  }, [_c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.item.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.item.username))]), _vm._v(" "), _c('div', {
    staticClass: "user-slug"
  }, [_vm._v("@" + _vm._s(_vm.item.slug))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.item.email))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("LOCATION")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.userFullAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("AGE GROUP")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.item.gender))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("SOCIAL PROFILE")]), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    _vm.item.social_provider.toLowerCase() === 'instagram'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Instagram - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://instagram.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    (_vm.item.social_provider.toLowerCase() === 'tiktok' ||
      _vm.item.social_provider.toLowerCase() === 'tik tok')
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("TikTok - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://tiktok.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    _vm.item.social_provider.toLowerCase() === 'facebook'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Facebook - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://facebook.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    _vm.item.social_provider.toLowerCase() === 'twitter'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Twitter - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://twitter.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.activeTab == 'waiting') ? _c('div', {
    staticClass: "action-section"
  }, [_c('v-btn', {
    staticClass: "approve-btn",
    attrs: {
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.approveButtonAction(_vm.item)
      }
    }
  }, [_vm._v("Approve")]), _vm._v(" "), _c('v-btn', {
    staticClass: "deny-btn",
    attrs: {
      "color": "error ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction()
      }
    }
  }, [_vm._v("Deny")])], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a55cb5c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/signup_approve_modal.vue
// module id = 1792
// module chunks = 180